import { render, staticRenderFns } from "./OpportunityForm.vue?vue&type=template&id=41d952aa&scoped=true"
import script from "./OpportunityForm.vue?vue&type=script&lang=js"
export * from "./OpportunityForm.vue?vue&type=script&lang=js"
import style0 from "./OpportunityForm.vue?vue&type=style&index=0&id=41d952aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d952aa",
  null
  
)

export default component.exports